import { render, staticRenderFns } from "./DashboardManager.vue?vue&type=template&id=325cfbf1"
import script from "./DashboardManager.vue?vue&type=script&lang=js"
export * from "./DashboardManager.vue?vue&type=script&lang=js"
import style0 from "./DashboardManager.vue?vue&type=style&index=0&id=325cfbf1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports